import React, { useEffect, useMemo, useState } from "react";
import "./App.css";
import { Toaster } from "react-hot-toast";
import {
  BrowserRouter,
  Routes,
  Route,
  Link,
  useLocation,
  Navigate
} from "react-router-dom";
import {
  PlusOutlined,
  CalendarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Layout, Menu, theme, Divider, Flex, Spin } from "antd";
import MeetingRoom from "./components/projectPages/MeetingRoom";
import Cr from "./components/projectPages/Calendar";
import User from "./components/headerItems/User";
import Rb from "./components/projectPages/Rb";
import { GetRole, refreshRoleFromDatabase } from "./userRole";
import AdminView from "./components/projectPages/AdminDashboard";
import MeetingCard from "./components/projectPages/UpNextMeetings";
import { SiGotomeeting } from "react-icons/si";
import { MdOutlineDashboard } from "react-icons/md";

const { Header, Sider } = Layout;
const { SubMenu } = Menu;

function App() {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const location = useLocation();
  const [role, setRole] = useState(GetRole());
  const [roleReady, setRoleReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    refreshRoleFromDatabase().then((resolvedRole) => {
      if (!mounted) return;
      setRole(resolvedRole);
      setRoleReady(true);
    });
    return () => {
      mounted = false;
    };
  }, []);

  const navMenuItems = useMemo(
    () =>
      [
        {
          key: "/calendar",
          icon: <CalendarOutlined />,
          label: <Link to="/calendar">Meeting Calendar</Link>,
        },
        {
          key: "/upNext-meetings",
          icon: <SiGotomeeting />,
          label: <Link to="/upNext-meetings">Upcoming Meetings</Link>,
        },
        {
          key: "/meeting-room-booking",
          icon: <CalendarOutlined />,
          label: <Link to="/meeting-room-booking">Book New Meeting</Link>,
        },
        role === "admin" && {
          key: "/meeting-room",
          icon: <PlusOutlined />,
          label: <Link to="/meeting-room">Add meeting room</Link>,
        },
        role === "admin" && {
          key: "/admin-view",
          icon: <MdOutlineDashboard />,
          label: <Link to="/admin-view">Admin dashboard</Link>,
        },
      ].filter(Boolean),
    [role]
  );

  if (!roleReady) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Layout style={{ height: "100%" }}>
      <Header
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Flex>
          <img
            src="https://spanlogo.s3.ap-south-1.amazonaws.com/spanidea-logo-light-2025.png"
            alt="logo"
            style={{ height: "30px" }}
          />
        </Flex>
        <Flex justify="center">
          <span
            style={{
              color: "white",
              fontSize: "25px",
              textAlign: "center",
              fontWeight: "600",
              marginRight: 40,
            }}
          >
            Spanidea Meeting
          </span>
        </Flex>
        <Flex style={{ paddingRight: "10px" }}>
          <User />
        </Flex>
      </Header>
      <Layout>
        <Sider
          width={200}
          style={{
            background: colorBgContainer,
          }}
        >
          <Menu
            mode="inline"
            defaultSelectedKeys={["/meeting-room-booking"]}
            selectedKeys={[location.pathname]}
            items={navMenuItems}
            style={{
              height: "auto",
              borderRight: 0,
              marginTop: "1rem",
            }}
          >
            {navMenuItems.map((menuItem, index) => {
              if (menuItem.children) {
                return (
                  <SubMenu
                    key={menuItem.key}
                    icon={menuItem.icon}
                    title={menuItem.label}
                  >
                    {menuItem.children.map((subItem) => (
                      <Menu.Item key={subItem.key} icon={subItem.icon}>
                        {subItem.label}
                      </Menu.Item>
                    ))}
                  </SubMenu>
                );
              }
              return (
                <>
                  <Menu.Item key={menuItem.path} icon={menuItem.icon}>
                    {menuItem.label}
                  </Menu.Item>
                  {index < navMenuItems.length - 1 && (
                    <Divider style={{ margin: 0 }} />
                  )}
                </>
              );
            })}
          </Menu>
        </Sider>
        <Layout className="contentWrapper">
          <div
            style={{
              padding: 24,
              background: colorBgContainer,
              borderRadius: borderRadiusLG,
              //height: "100%",
            }}
          >
            <Routes>
              {/* <Route path="/" element={<Cr />} /> */}

              <Route path="/" element={<Navigate to="/meeting-room-booking" replace />} />


              <Route path="/calendar" element={<Cr />} />

              {role === "admin" && (
                <Route path="/meeting-room" element={<MeetingRoom />} />
              )}
              {/* <Route path="/meetings" element={<Cr />} /> */}
              <Route path="/meeting-room-booking" element={<Rb />} />
              <Route path="/admin-view" element={<AdminView />} />
              <Route path="/upNext-meetings" element={<MeetingCard />} />
            </Routes>
          </div>
        </Layout>
      </Layout>
    </Layout>
  );
}

function AppWrapper() {


  return (
    <BrowserRouter>
      <App />
      <Toaster />
    </BrowserRouter>
  );
}

export default AppWrapper;
